import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { findColor } from '@as-react/common-utils';
import { Button, ButtonSize, ButtonVariant, CheckboxWithLabel, Group, GroupAlign, GroupGutter, GroupVerticalAlign, IconAnimation, IconName, IconSize, Overlay, ProductTile, Text, TextColor, TextSize, } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getPortraitImageSizeUrlByProductCode } from '../../../util/ImageUtil';
import { getProductDetailUrl } from '../../../util/ProductUtil';
import { ProductImageHeight, ProductImageWidth } from '../../../constants/ProductConstants';
import { usePriceProps } from '../../../hooks/usePriceProps';
import { Price } from '@yonderland/andes-react';
export const AlternativeProductTile = ({ product, onWishListToggle, updateCompareList, }) => {
    var _a, _b;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { root, isShopLanding, feature_toggles: { product_compare, lowest_price_all }, productImageConfig, } = useAemConfig();
    const selectedColor = findColor(product.colours, product.colourId);
    const productUrl = getProductDetailUrl(product, root);
    const compareCheckboxId = `product-compare-alternative-${product.productCode}-${product.colourId}`;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: selectedColor.prices,
            hasDiscount: selectedColor.hasDiscount,
        },
        enablePriceReference: lowest_price_all,
    });
    const image = getPortraitImageSizeUrlByProductCode(product.productCode, selectedColor.image, productImageConfig.cdnDomains, ProductImageSizesPortraitEnum.basket);
    const handleWishListClick = () => onWishListToggle({
        productCode: product.productCode,
        productId: product.productId,
        colorId: selectedColor.colourId,
    });
    const handleCompareClick = () => updateCompareList({
        brand: product.brand,
        color: selectedColor.colourId,
        image: selectedColor.image,
        productCode: product.productCode,
        selected: false,
        id: product.productId,
        title: product.title,
        gender: product.genderCode,
        url: productUrl,
        colorDescription: selectedColor.description,
        collapsedComparePopup: true,
    });
    return (_jsxs(ProductTile, { variant: "horizontal", product: {
            image,
            alt: product.title,
            title: product.title,
            brand: product.brand,
            review: {
                amount: (_a = product.productReviews) !== null && _a !== void 0 ? _a : 0,
                score: (_b = product.productRating) !== null && _b !== void 0 ? _b : 0,
            },
        }, children: [_jsx(ProductTile.Area, { area: "primary", href: productUrl, children: _jsx(ProductTile.Image, { lazyLoad: true, width: ProductImageWidth.ALTERNATIVE_TILE, height: ProductImageHeight.ALTERNATIVE_TILE }) }), _jsx(ProductTile.Area, { area: "secondary", href: productUrl, containerOptions: { mobile: { spacing: { paddingLeft: 1.5 } } }, children: _jsxs(Group, { column: true, gutter: GroupGutter.SMALL, children: [_jsx(ProductTile.Title, { brandOnTheSameLine: true, reserveLine: 2, lineClamp: 2, size: TextSize.MEDIUM, containerOptions: { mobile: { spacing: { marginRight: 3 } } } }), _jsx(ProductTile.Rating, {}), !!priceProps && _jsx(Price, Object.assign({}, priceProps)), _jsxs(Text, { size: TextSize.SMALL, color: TextColor.SUBTLE, children: [product.colours.length, " ", t('lister.swatch.counter', { count: product.colours.length })] }), product_compare && (_jsx(CheckboxWithLabel, { id: compareCheckboxId, name: compareCheckboxId, value: compareCheckboxId, labelChildren: t('productCompare.pdp.checkbox'), checked: selectedColor.isCompareProduct || false, onChange: handleCompareClick }))] }) }), !isShopLanding && (_jsx(Overlay, { noPointerEvents: true, children: _jsx(Group, { fullHeight: true, gutter: GroupGutter.NONE, align: GroupAlign.RIGHT, valign: GroupVerticalAlign.TOP, children: _jsx(Button, { onClick: handleWishListClick, variant: ButtonVariant.INVERSE_ALT, size: ButtonSize.XSMALL, icon: {
                            name: selectedColor.inWishList ? IconName.HEART : IconName.HEART_EMPTY,
                            size: IconSize.MEDIUM,
                            animation: selectedColor.inWishList ? IconAnimation.HEART_PULSE : undefined,
                        } }) }) }))] }));
};
